import { Component, OnInit, Inject } from '@angular/core';
import * as moment from 'moment';
import { IMessageStatusLogModel } from 'src/app/ViewModel/CommunicationModel';
import { CommunicationService } from 'src/app/Service/communication/communication.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-mail-status-log',
  templateUrl: './mail-status-log.component.html',
  styleUrls: ['./mail-status-log.component.css']
})
export class MailStatusLogComponent implements OnInit {
  public statusList: IMessageStatusLogModel[] = [];
  public messageNo:string='';
  public messageSubject:string='';

  constructor(
    private communicationService: CommunicationService,
    public dialogRef: MatDialogRef<MailStatusLogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

  ngOnInit() {
    this.messageNo=this.data.messageNo;
    this.messageSubject=this.data.messageSubject;
    this.initGrid(this.data.messageId);
  }

  public async initGrid(msgId:number){
    let result = await this.communicationService.getMessageStatusLog(msgId).toPromise();
    this.statusList=result.filter((x: { messageNumber: string; })=>x.messageNumber==this.messageNo);
  }
  public togglePopupDialog() {
    this.dialogRef.close();
  }

}
